import { Component, Input, OnInit } from '@angular/core';
import { Router } from '@angular/router';
import { EmployeeComponent } from 'src/app/employee/employee.component';
import { SharedService } from 'src/app/shared.service';
import { AttendanceSummaryComponent } from '../attendance-summary.component';
import swal from 'sweetalert'

@Component({
  selector: 'app-attendance-summary-edit',
  templateUrl: './attendance-summary-edit.component.html',
  styleUrls: ['./attendance-summary-edit.component.scss']
})
export class AttendanceSummaryEditComponent implements OnInit
{

  constructor(private service:SharedService)
  {

  }

  @Input() Date: any;
  @Input() employee: any;
  @Input() attendanceList: any;
  @Input() clockifyList: any;

  clockify: any;
  attendance: any;
  employeeName: any;
  Arrival: any;
  Departure: any;

  Leave: any;
  Type: any;

  time: any;

  clockifyHours: any;


  ngOnInit(): void
  {
    this.GetAttendance(this.Date.pkDate, this.employee.pkEmpId);
    this.GetClockify(this.Date.pkDate, this.employee.ClockifyId);
    this.GetLeave();
    this.employeeName = this.employee.FirstName.concat(' ', this.employee.LastName);
    this.GetVariables();
    this.RefreshType();
  }


  GetVariables()
  {
    if (this.IsTechnical())
    {
        this.clockifyHours = this.clockify?.DurationInMinutes;
        this.RefreshType();
    }
    else
    {
      if(!this.CheckLeave())
      {
        this.Arrival = this.attendance.Arrival;
        this.Departure = this.attendance.Departure;
      }
    }
  }


  Test()
  {
    console.log(this.clockify)
  }


  GetAttendance(date: any, id: number)
  {
    for(var att of this.attendanceList)
    {
      if(att.fkEmpId == id)
      {
        if(att.Date == date)
        {
          this.attendance = att;
          return
        }
      }
    }
  }


  GetClockify(date: any, clockifyId: any)
  {
    for(var clockify of this.clockifyList)
    {
      if(clockify.ClockifyId == clockifyId)
      {
        if(clockify.Date == date)
        {
          this.clockify = clockify;
          return
        }
      }
    }
  }


  IsTechnical()
  {
    if (this.employee.ClockifyId == '')
    {
      return false
    }
    else
    {
      return true
    }
  }


  RefreshType()
  {
    setTimeout(() =>
    {
      this.Type = this.Leave[0]?.Type;
    }, 200);
  }


  UpdateAttendance()
  {
    var val =
    {
      pkAttendanceId: this.attendance.pkAttendanceId,
      fkEmpId: this.attendance.fkEmpId,
      Arrival: this.Arrival,
      Departure: this.Departure,
      Date: this.attendance.Date,
      DurationOfTasks: this.attendance.DurationOfTasks
    };

    if(val.Arrival[0]!=undefined)
    {
      console.log('inside')
      document.getElementById('Arrival')?.setAttribute("style","border:2px solid white")
      if(val.Arrival[0].concat(val.Arrival[1])>23 ||val.Arrival[0].concat(val.Arrival[1])<0)
      {
        document.getElementById('Arrival')?.setAttribute("style","color:red; border:2px solid red")
        swal("Validation Error", 'Arrival time format is incorrect', "error")
      }
      if(val.Departure[0]!=undefined)
      {
        document.getElementById('departure')?.setAttribute("style","border:2px solid white")
        if(val.Departure[0].concat(val.Departure[1])>23 ||val.Departure[0].concat(val.Departure[1])<0)
        {
          document.getElementById('departure')?.setAttribute("style","color:red; border:2px solid red")
          swal("Validation Error", 'Departure time format is incorrect', "error")
        }
      if(val.Departure[0].concat(val.Departure[1])<=23 && val.Departure[0].concat(val.Departure[1])>=0)
      {
        document.getElementById('departure')?.setAttribute("style","border:2px solid white")
        this.service.UpdateAttendance(val).subscribe(data =>
          {
            swal("Validation Error", data.toString(), "error")
          });
        }
      }
      else if(val.Departure[0]==undefined)
      {
        document.getElementById('departure')?.setAttribute("style","color:red; border:2px solid red")
        swal("Validation Error", 'Departure time is empty', "error")
      }
    }
    else
    {
      document.getElementById('Arrival')?.setAttribute("style","color:red; border:2px solid red")
      swal("Validation Error", 'Arrival time is empty', "error")
    }
  }


  AddAttendance()
  {
    var val =
    {
      fkEmpId: this.employee.pkEmpId,
      Arrival: this.Arrival,
      Departure: this.Departure,
      Date: this.Date.pkDate,
    };
        if(val.Arrival!=null)
        {
          document.getElementById('Arrival')?.setAttribute("style","border:2px solid white")
          if(val.Arrival[0].concat(val.Arrival[1])>23 ||val.Arrival[0].concat(val.Arrival[1])<0)
          {
            document.getElementById('Arrival')?.setAttribute("style","color:red; border:2px solid red")
            swal("Validation Error", 'Arrival time format is incorrect', "error")
          }
          if(val.Departure!=null)
          {
            document.getElementById('departure')?.setAttribute("style","color:white; border:2px solid white")
            if(val.Departure[0].concat(val.Departure[1])>23 ||val.Departure[0].concat(val.Departure[1])<0)
            {
              document.getElementById('departure')?.setAttribute("style","color:red; border:2px solid red")
              swal("Validation Error", 'Departure time format is incorrect', "error")
            }
            if(val.Departure[0].concat(val.Departure[1])<=23 && val.Departure[0].concat(val.Departure[1])>=0)
            {
              document.getElementById('departure')?.setAttribute("style","color:white")
              this.service.AddAttendance(val).subscribe(data =>
              {
                swal("Validation Error", data.toString(), "error")
              });
            }
          }
          else if(val.Departure==null)
          {
            document.getElementById('departure')?.setAttribute("style","color:red; border:2px solid red")
            swal("Validation Error", 'Departure time is empty', "error")
          }
        }
        else
        {
          document.getElementById('Arrival')?.setAttribute("style","color:red; border:2px solid red")
          swal("Validation Error", 'Arrival time is empty', "error")
        }
  }


  DeleteAttendance(id: number)
  {
    swal
    ({
      title: "Are you sure?",
      text: "Deleting this record is an irreviersible action",
      icon: "warning",
      buttons:
      {
        cancel: true,
        confirm: true,
      },
      dangerMode: true,
    })
    .then((confirm) =>
    {
      if(confirm)
      {
        this.service.DeleteAttendance(id).subscribe(data =>
        {
          swal(data.toString(), '', "info")
        });
      }
    });
  }


  DeleteClockify(id: number)
  {
    swal
    ({
      title: "Are you sure?",
      text: "Deleting this record is an irreviersible action",
      icon: "warning",
      buttons:
      {
        cancel: true,
        confirm: true,
      },
      dangerMode: true,
    })
    .then((confirm) =>
    {
      if(confirm)
      {
        this.service.DeleteClockify(id).subscribe(data =>
        {
          swal(data.toString(), '', "info")
        });
      }
    });
  }


  GetLeave()
  {
    this.service.GetEmployeeLeaveForDay(this.employee.pkEmpId, this.Date.pkDate).subscribe(data =>
    {
      this.Leave = data;
    });
  }


  UpdateLeave()
  {
    var val =
    {
    pkEmpLeaveId: this.Leave[0].pkEmpLeaveId,
    fkEmpId: this.Leave[0].fkEmpId,
    Date: this.Leave[0].Date,
    Type: this.Type
    };
    this.service.UpdateEmployeeLeave(val).subscribe(res =>
    {
      swal(res.toString(), '', "info")
    });
  }


  CheckLeave()
  {
    if (this.IsTechnical())
    {
      if(this.clockify?.WorkHours == undefined)
      {
        return true
      }
      else
      {
        return false
      }
    }
    else
    {
      if (this.attendance?.WorkHours == undefined)
      {
        return true
      }
      else
      {
        return false
      }
    }
  }

}
